<template>
  <v-card>
    <v-card-title primary-title>
      Tax Rates
      <v-spacer />
      <TaxRateForm>
        <template #activator="{ on }">
          <v-btn v-on="on">
            Add Tax Rate
          </v-btn>
        </template>
      </TaxRateForm>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="taxRates"
        :loading="loading"
        :options.sync="options"
        :server-items-length="totalCount"
      >
        <template #item.actions="{item}">
          <TaxRateForm :rate="item">
            <template #activator="{ on }">
              <v-btn small icon v-on="on">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
          </TaxRateForm>
          <v-btn icon small @click="deleteItem(item)">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
          </template>
      </v-data-table>
      <ConfirmBox ref="confirm" />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from "lodash";
import ConfirmBox from '../../../components/ui/ConfirmBox.vue'
import TaxRateForm from '../../../components/taxrates/form.vue'
export default {
  components: {
    ConfirmBox,
    TaxRateForm
  },
  data: () => ({
    headers: [
      { text: "Name", value: "name", align: "left" },
      { text: "Rate", value: "taxRate", align: "left" },
      { text: "Country", value: "country", align: "left" },
      { text: "Actions", value: "actions", align: "right" }
    ],
    options: { rowsPerPage: 10 },
  }),
  mounted: function() {
    this.getTaxRateList();
  },
  watch: {
    options: {
      handler: _.debounce(function() {
        this.getTaxRateList();
      }, 100)
    }
  },
  computed: {
    ...mapGetters('taxRates', ['taxRates', 'loading', 'totalCount'])
  },
  methods: {
    ...mapActions('taxRates', { fetchTaxRates : 'index'}),
    getTaxRateList() {
      this.fetchTaxRates({
        pagination: this.options
      });
    },
    async deleteItem(item) {
      if(await this.$refs.confirm.open("Are you sure ?", "Are you sure to want to delete this tax rate ?")){
        this.$store
          .dispatch("taxRates/delete", {
            model: item
          })
          .then(() => {
            this.getTaxRateList();
            this.flashMessage.success({
              message: 'Tax Rate deleted succesfully',
            })
          })
          .catch(({data}) => {
            console.log("data",data);
            this.flashMessage.error({
              message: 'Error: This Tax Rate is used somewhere else',
            })
          });
      }
    }
  }
};
</script>
